<template>
	<div class="addMain">
		<el-form :model="form" :rules="rules" ref="frmAdd" label-width="100px" class="demo-ruleForm">
			<el-form-item label="姓名" prop="name"><el-input v-model="form.name"></el-input></el-form-item>
			<!-- <el-form-item label="地址" prop="ip"><el-input v-model="form.ip"></el-input></el-form-item> -->
			<el-form-item label="身份证" prop="idcardno"><el-input v-model="form.idcardno" disabled="true"></el-input></el-form-item>
			<el-form-item label="联系方式" prop="mobile"><el-input v-model="form.mobile" disabled="true"></el-input></el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			form: {
				
			},
			options: [],
			value: '',
			rules: {
				name: [
					{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}
				],
				idcardno: [
					{
						required: true,
						message: '请输入身份证',
						trigger: 'blur'
					}
				],
				mobile: [
					{
						required: true,
						message: '请输入联系方式',
						trigger: 'blur'
					}
				]
			}
		};
	},
	mounted() {
		
	},
	methods:{
		
		},
	
};
</script>

<style scoped>
	.addMain .el-row{
		display: flex;
		align-items: center;
	}
	.addMain .el-row{
		margin-bottom:20px;
	}
	.addMain .el-select{
		width:100%;
	}
	.addMain .el-option{
		width:100%;
	}
</style>
